import { trpc } from '../../App'

export function useAkteServiceContractLines({ id }: { id: number }) {
  const akteServiceContractLines = trpc.akte.serviceContractLines.useQuery({ id })
  return akteServiceContractLines
}
